import {
  jb_service_navigation_css_default
} from "./chunk.4ZDPWVDE.js";
import {
  e
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-service-navigation/jb-service-navigation.ts
var JbServiceNavigation = class extends Initiable(i) {
  render() {
    return b`
      <div
        class=${e({
      "service-navigation": true,
      "service-navigation--hide-first": this.hideItems === "first",
      "service-navigation--hide-all-except-first": this.hideItems === "all-except-first",
      "service-navigation--hide-all": this.hideItems === "all"
    })}
      >
        <slot></slot>
      </div>
    `;
  }
};
JbServiceNavigation.styles = [reset_css_default, jb_service_navigation_css_default];
__decorateClass([
  n()
], JbServiceNavigation.prototype, "hideItems", 2);
JbServiceNavigation = __decorateClass([
  customElement("jb-service-navigation")
], JbServiceNavigation);

export {
  JbServiceNavigation
};
